import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import _Header from '../_app/cuchillo/layout/Header';
import { Power3, gsap } from "gsap";

export default class Header extends _Header {
  static options = {
    show: {
      duration: .6,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static show__effect() {
    EventDispatcher.dispatchEvent(_Header.ON_SHOW);

    gsap.to(this.container, {
      opacity: 1,
      duration: this.options.show.duration,
      delay: this.options.show.delay,
      ease: this.options.show.duration.ease,
      onComplete: () => {
        this.isShowing = false;
      }
    });
  }

  static hide__effect() {
    EventDispatcher.dispatchEvent(_Header.ON_HIDE);
    gsap.to(this.container, {
      opacity: 0,
      duration: this.options.hide.duration,
      delay: this.options.hide.delay,
      ease: this.options.hide.duration.ease,
      onComplete: () => {
        this.isShowing = false;
      }
    });
  }

  static directHide() {
    this.isShow = false;
    gsap.set(this.container, {
      opacity: 0
    });
  }
}
